'use client';

import { createWorker, OEM, PSM } from 'tesseract.js';

export type TesseractWorkerLike = Awaited<ReturnType<typeof createWorker>>;

export type BrowserOcrProgress = {
  label: string;
  progress: number;
};

export function formatOcrStatus(status: string) {
  switch (status) {
    case 'loading tesseract core':
      return 'Loading OCR engine…';
    case 'initializing tesseract':
      return 'Initializing OCR engine…';
    case 'loading language traineddata':
      return 'Loading language data…';
    case 'initializing api':
      return 'Preparing OCR worker…';
    case 'recognizing text':
      return 'Recognizing current page…';
    default:
      return status ? `${status.charAt(0).toUpperCase()}${status.slice(1)}…` : 'Processing…';
  }
}

export function normalizeRecognizedText(text: string) {
  return text.replace(/\n{3,}/g, '\n\n').trim();
}

export function countWords(text: string) {
  return text ? text.split(/\s+/).filter(Boolean).length : 0;
}

export async function createEnglishOcrWorker(onProgress: (progress: BrowserOcrProgress) => void) {
  const worker = await createWorker('eng', OEM.LSTM_ONLY, {
    workerPath: '/tesseract-worker.min.js',
    corePath: '/tesseract-core-simd-lstm.wasm.js',
    logger: (message: { status: string; progress: number }) => {
      onProgress({
        label: formatOcrStatus(message.status),
        progress: Math.max(0, Math.min(1, message.progress ?? 0)),
      });
    },
  });

  await worker.setParameters({
    tessedit_pageseg_mode: PSM.AUTO,
    preserve_interword_spaces: '1',
  });

  return worker;
}
